
import {getAuthorization} from '../api/getAuthorization';
import {setAuthorizeAction, setAdminAction} from '../action';

const setAuthorize = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getAuthorization(params);
    
            if (data.status === 'success') {
                localStorage.setItem('token', data.token);
                dispatch(setAuthorizeAction(true));
                dispatch(setAdminAction(data.admin));
            }
        } catch(error) {
            localStorage.removeItem('token');
            window.location.replace(window.location.origin);
        }
    }
}

export {
    setAuthorize
}